import contextCreator from "../contextCreator";
import favListingsReducer, { initialState } from "./favListings.reducer";

// eslint-disable-next-line react-hooks/rules-of-hooks
const [state, dispatch, provider] = contextCreator(
  favListingsReducer,
  initialState
);

export const useFavListingsState = state;
export const useFavListingsDispatch = dispatch;
export const FavListingsProvider = provider;
